export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function startWithLowercase(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}
